/**
 * Best-effort live-path set for sidebar pins. Stale pins stay in localStorage
 * but render muted until the owner unpins them.
 */
export interface SidebarPinPathInput {
  dashboardPath?: string;
  entityPaths: string[];
  reportPaths: string[];
  menuPaths: string[];
}

export function collectSidebarPinPaths(input: SidebarPinPathInput): Set<string> {
  const paths = new Set<string>();
  if (input.dashboardPath) {
    paths.add(input.dashboardPath);
  }
  for (const path of [...input.entityPaths, ...input.reportPaths, ...input.menuPaths]) {
    if (path) {
      paths.add(path);
    }
  }
  return paths;
}

/** When entities are not loaded yet, never mark a pin stale (avoid flash). */
export function isSidebarPinStale(
  pinPath: string,
  livePaths: Set<string>,
  entitiesLoaded: boolean,
): boolean {
  if (!entitiesLoaded) {
    return false;
  }
  return !livePaths.has(pinPath);
}
